import ConstructionMessage from './ConstructionMessage'

export default ConstructionMessage
// eslint-disable-next-line import/export
export * from './ConstructionMessage'
